import { useEffect, useRef, useState } from "react"
import { FaArrowUp } from "react-icons/fa6"
import useT from "utils/hooks/useT"
import { FileAttachmentButton, FileAttachmentChips } from "components/FileAttachment"
import { chatStore, registerInputHandle } from "./chatStore"

export default function Sender({ inputDisabled, handleNewUserMessage, files, onAddFiles, onRemoveFile, onClearFiles, onPaste, children }) {
  const { t } = useT("common")
  const textareaRef = useRef(null)
  const [inputValue, setInputValue] = useState("")
  const inputValueRef = useRef("")

  const updateValue = (v) => {
    inputValueRef.current = v
    setInputValue(v)
  }

  useEffect(() => {
    registerInputHandle(() => inputValueRef.current, updateValue)
  }, [])

  useEffect(() => {
    const ta = textareaRef.current
    if (!ta) return
    ta.style.height = "auto"
    ta.style.height = `${Math.min(ta.scrollHeight, 160)}px`
  }, [inputValue])

  const submit = () => {
    if (inputDisabled) return
    const trimmed = inputValue.trim()
    if (!trimmed && files.length === 0) return
    const filesToSend = [...files]
    chatStore.addUser(trimmed, filesToSend.map(f => ({ filename: f.name, size: f.size })))
    updateValue("")
    onClearFiles()
    handleNewUserMessage(trimmed, filesToSend)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    submit()
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      submit()
    }
  }

  return (
    <div className="chat-sender">
      <FileAttachmentChips files={files} onRemoveFile={onRemoveFile} />
      <form className="chat-input" onSubmit={handleSubmit}>
        <FileAttachmentButton
          files={files}
          onAddFiles={onAddFiles}
          disabled={inputDisabled}
        />
        {children}
        <textarea
          ref={textareaRef}
          className="rcw-input"
          value={inputValue}
          onChange={(e) => updateValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onPaste={onPaste}
          placeholder={t("typeYourMessage")}
          disabled={inputDisabled}
          rows={1}
        />
        <button type="submit" className="send-button" disabled={inputDisabled} aria-label="Send">
          <FaArrowUp />
        </button>
      </form>
    </div>
  )
}
